import { CheckCircle2, Clock, Wrench, MapPin } from "lucide-react";

const FEATURES = [
  {
    icon: MapPin,
    title: "Mid-South locals",
    body: "We live where we work. From Memphis to Tupelo, we know the climate, the codes, and the property managers.",
  },
  {
    icon: Clock,
    title: "After-hours scheduling",
    body: "Most projects happen overnight or on weekends so your business never closes — or even slows down.",
  },
  {
    icon: Wrench,
    title: "Commercial-grade materials",
    body: "Traffic-rated paint, hot-pour crack filler, and pro sealer — never the cheap stuff that fades in a season.",
  },
  {
    icon: CheckCircle2,
    title: "Clear, fixed-price quotes",
    body: "No surprises and no change-order games. The price we walk you through is the price you pay.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-choose-us"
      className="py-20 md:py-28 bg-slate-50 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-blue-700">
              Why 901 Lots
            </div>
            <h2 className="mt-3 font-display font-bold tracking-tight text-slate-900 text-3xl sm:text-4xl">
              Built for property managers who don't have time for excuses.
            </h2>
            <p className="mt-5 text-base text-slate-600 leading-relaxed">
              You need a parking lot that's safe, looks sharp, and won't
              cost you a single lost customer. That's all we do — and we
              do it across the entire Mid-South.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {FEATURES.map((f) => (
              <div
                key={f.title}
                data-testid={`why-feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-white border border-slate-200 p-6 rounded-lg hover:border-blue-300 hover:shadow-md transition-all"
              >
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-orange-50 text-orange-600">
                  <f.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-4 font-display font-semibold text-slate-900 text-lg">
                  {f.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                  {f.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
